import { balanceControllerGetBalanceBySchoolId } from './balanceControllerGetBalanceBySchoolId'
import { balanceControllerTopUpBalance } from './balanceControllerTopUpBalance'
import { balanceControllerWithdrawBalance } from './balanceControllerWithdrawBalance'

export const balanceService = { balanceControllerGetBalanceBySchoolId, balanceControllerTopUpBalance, balanceControllerWithdrawBalance }